import React from "react";

const Footer = () => {
  // Get the current year
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-auto py-3 bg-white text-center">
      <div className="container">
        <span className="text-muted">
          {" "}
          Copyright © {currentYear} All rights reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
